webpackJsonp([40],{

/***/ 1033:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"page-distribution-resource"},[_c('header-page',{attrs:{"name":"distribution","title":_vm.$route.meta.title}}),_vm._v(" "),_c('div',{staticClass:"px-5 mb-5"},[_c('app-table',{staticClass:"mt-5",attrs:{"columns":_vm.columns,"check-all":_vm.checkAll,"selected-value":_vm.selectedValue,"selectable":"","rows":_vm.rows,"check-row":_vm.checkRow,"current-page":_vm.currentPage,"last-page":this.lastPage},on:{"on-search-event":_vm.onSearch,"on-page":_vm.changePage,"row-is-selected":_vm.rowIsSelected,"on-selected-all":_vm.allIsSelected},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.row.razonSocial))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.row.codeCompany))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.row.ruc))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.row.country ? props.row.country.data.name : ''))]),_vm._v(" "),_c('td',[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"btn-action btn-distribution",attrs:{"slot":"activator"},on:{"click":function($event){return _vm.openConfirmDialog(props.row)}},slot:"activator"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("tune")])],1),_vm._v(" "),_c('span',[_vm._v("Personalización a la empresa")])],1),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"primary","icon":"people_outline","text":"Usuarios por compañia"},on:{"click-icon":function($event){return _vm.goToUser(props.row)}}})],1)]}}])}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.dialogMessage))]),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"btn-action",attrs:{"color":"green","dark":"","disabled":_vm.loading},nativeOn:{"click":function($event){return _vm.postDistribution.apply(null, arguments)}}},[_vm._v("\n\t\t\t\t\t\t\t\t\tSI\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action",attrs:{"color":"error","dark":""},nativeOn:{"click":function($event){return _vm.close.apply(null, arguments)}}},[_vm._v("\n\t\t\t\t\t\t\t\t\tNO\n\t\t\t\t\t\t\t\t")])],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center mt-5"},[_c('v-btn',{staticClass:"btn-action caption mr-1",attrs:{"color":"primary"},on:{"click":_vm.returnDistribution}},[_vm._v("\n\t\t\t\t\t\tCancelar\n\t\t\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption mr-1",attrs:{"color":"green"},on:{"click":_vm.updateDistribution}},[_vm._v("\n\t\t\t\t\t\tDistribuir\n\t\t\t\t\t")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_distribution_of_resources_vue__ = __webpack_require__(833);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d003956_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_distribution_of_resources_vue__ = __webpack_require__(1033);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_distribution_of_resources_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d003956_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_distribution_of_resources_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function clickIcon() {
	this.$emit('click-icon');
}

function isListAll() {
	return this.icon === 'list_all' ? 'height:24px;width:24px' : '';
}

function buttonColor() {
	return this.isEditAction ? '#3B82C4' : this.color;
}

function isEditAction() {
	return ['edit', 'create'].includes(this.icon);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-tooltip-button',
	computed: {
		buttonColor: buttonColor,
		isEditAction: isEditAction,
		isListAll: isListAll
	},
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: 'green'
		},
		icon: {
			type: String,
			required: true
		},
		text: {
			type: String,
			required: true
		}
	},
	methods: {
		clickIcon: clickIcon
	}
});

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__ = __webpack_require__(559);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01775c3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__ = __webpack_require__(564);
function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01775c3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01775c3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(563);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("673c19a2", content, true, {});

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.action-icon-button[data-v-01775c3c]{background:#f2f6f9!important;border:1px solid transparent;border-radius:7px;height:28px;min-width:28px;-webkit-transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease,-webkit-transform .16s ease;width:28px}.action-icon-button .icon[data-v-01775c3c]{font-size:17px}.action-icon-button[data-v-01775c3c]:hover{background:#eaf3ef!important;border-color:#c8ddd5;-webkit-transform:translateY(-1px);transform:translateY(-1px)}.action-icon-button.is-edit-action[data-v-01775c3c]:hover{background:#eaf3fa!important;border-color:#bed8ea}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/app-tooltip-button.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,qCAAqC,6BAA8B,6BAA+B,kBAAkB,YAAY,eAAe,2FAA2F,mFAAmF,2EAA2E,uGAAuG,UAAU,CACxf,AACD,2CAA2C,cAAc,CACxD,AACD,2CAA2C,6BAA8B,qBAAqB,mCAAmC,0BAA0B,CAC1J,AACD,0DAA0D,6BAA8B,oBAAoB,CAC3G","file":"app-tooltip-button.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.action-icon-button[data-v-01775c3c]{background:#f2f6f9 !important;border:1px solid rgba(0,0,0,0);border-radius:7px;height:28px;min-width:28px;-webkit-transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease,-webkit-transform .16s ease;width:28px\n}\n.action-icon-button .icon[data-v-01775c3c]{font-size:17px\n}\n.action-icon-button[data-v-01775c3c]:hover{background:#eaf3ef !important;border-color:#c8ddd5;-webkit-transform:translateY(-1px);transform:translateY(-1px)\n}\n.action-icon-button.is-edit-action[data-v-01775c3c]:hover{background:#eaf3fa !important;border-color:#bed8ea\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"action-icon-button ma-0",class:{ 'is-edit-action': _vm.isEditAction },attrs:{"slot":"activator","flat":"","icon":"","aria-label":_vm.text,"small":"","color":_vm.buttonColor,"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.clickIcon.apply(null, arguments)}},slot:"activator"},[_c('v-icon',{style:(_vm.isListAll)},[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 833:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_app_tooltip_button__ = __webpack_require__(560);




var updateDistribution = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var newArrayDistribution, headers, body, url;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						newArrayDistribution = this.dataSelected.map(function (item) {
							return item.id;
						});
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						body = {
							companiesId: newArrayDistribution
						};
						url = 'project/' + this.codeProject + '/distribution/' + this.idDistribution;
						_context.prev = 4;
						_context.next = 7;
						return this.$http.patch(url, body, { headers: headers });

					case 7:
						this.showNotification('Se ha distribuido los recursos');
						_context.next = 13;
						break;

					case 10:
						_context.prev = 10;
						_context.t0 = _context['catch'](4);

						if (_context.t0.status === 405) {
							if (_context.t0.data.message === "TEMPLATE_HAVEN'T_ASSOCIATED_DATA") {
								this.showNotification('Plantilla no tiene datos asociados');
							}
						}

					case 13:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[4, 10]]);
	}));

	return function updateDistribution() {
		return _ref.apply(this, arguments);
	};
}();

var postDistribution = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						this.loading = true;
						_context2.prev = 1;
						_context2.next = 4;
						return this.$http.post('template/' + this.idDistribution + '/companies/' + this.rowId);

					case 4:
						this.showNotification('Se ha generado una nueva plantilla relacionada a su compa\xF1ia ' + this.nameCompany);
						this.close();
						this.listDistribution();
						_context2.next = 12;
						break;

					case 9:
						_context2.prev = 9;
						_context2.t0 = _context2['catch'](1);

						this.showError();

					case 12:
						_context2.prev = 12;

						this.loading = false;
						return _context2.finish(12);

					case 15:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[1, 9, 12, 15]]);
	}));

	return function postDistribution() {
		return _ref2.apply(this, arguments);
	};
}();

var listDistribution = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.prev = 0;
						params = {
							params: this.params
						};
						_context3.next = 4;
						return this.$http.get('template/' + this.idDistribution + '/companies', params);

					case 4:
						response = _context3.sent;

						this.rows = response.data.data;
						this.lastPage = Number(response.headers['x-last-page']);
						this.checkAll = this.rows.every(function (r) {
							return r.isSelected;
						});
						this.dataSelected = this.rows.filter(function (r) {
							return r.isSelected;
						});
						_context3.next = 14;
						break;

					case 11:
						_context3.prev = 11;
						_context3.t0 = _context3['catch'](0);

						this.showError();

					case 14:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[0, 11]]);
	}));

	return function listDistribution() {
		return _ref4.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function openConfirmDialog(_ref3) {
	var id = _ref3.id,
	    razonSocial = _ref3.razonSocial;

	this.nameCompany = razonSocial;
	this.rowId = id;
	this.dialogMessage = '\xBFDesea hacerle una personalizaci\xF3n a la empresa \'' + razonSocial + '\'?';
	this.dialog = true;
}

function close() {
	this.dialog = false;
}

function created() {
	this.listDistribution();
}

function returnDistribution() {
	this.goTo('page-template');
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.listDistribution();
}

function onSearch(value) {
	this.params.search = value;
	this.listDistribution();
}

function rowIsSelected(row) {
	this.rows = this.selectIsRow(this.rows, this.selectedValue, row);
	this.checkAll = this.every(this.rows, this.selectedValue);
	this.setDataSelected(row);
}

function setDataSelected(row) {
	var _this = this;

	if (!row) {
		if (this.checkAll) {
			this.table.rows.forEach(function (rowData) {
				var index = _this.dataSelected.finIndex(function (d) {
					return d.id === rowData.id;
				});
				if (index < 0) {
					_this.dataSelected.push(rowData);
				}
			});
		} else {
			this.table.rows.forEach(function (rowData) {
				var index = _this.dataSelected.finIndex(function (d) {
					return d.id === rowData.id;
				});
				if (index >= 0) {
					_this.dataSelected.splice(index, 1);
				}
			});
		}
	} else {
		var index = this.dataSelected.findIndex(function (d) {
			return d.id === row.id;
		});
		if (index < 0) {
			this.dataSelected.push(row);
		} else {
			this.dataSelected.splice(index, 1);
		}
	}
}

function allIsSelected(checked) {
	this.checkAll = checked;
	this.rows = this.selectIsRow(this.rows, this.selectedValue, false, checked);
	this.dataSelected = checked ? this.rows : [];
}

function goToUser(_ref5) {
	var codeCompany = _ref5.codeCompany;

	this.goTo('page-user', {
		params: { codeProject: this.codeProject, idCompany: codeCompany },
		query: {
			returnTo: 'page-distribution-of-resources',
			returnParams: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
				codeProject: this.codeProject,
				idDistribution: this.idDistribution
			})
		}
	});
}

function data() {
	return {
		dataSelected: [],
		loading: false,
		checkAll: false,
		checkRow: false,
		companiesId: '',
		selectedValue: 'isSelected',
		dialogMessage: '',
		dialog: false,
		codeApp: '',
		currentPage: 1,
		lastPage: 1,
		rows: [],
		columns: [{ id: 1, name: 'Nombre', value: 'name', checked: true, visible: true }, { id: 2, name: 'Código Compañía', value: 'code', checked: true, visible: true }, { id: 3, name: 'RUC', value: 'ruc', checked: true, visible: true }, { id: 4, name: 'Estado', value: 'state', checked: true, visible: true }, { id: 5, name: 'Acciones', value: 'action', checked: true, visible: true }],
		params: {
			page: 1,
			perPage: 20,
			search: null
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-distribution-of-resources',
	created: created,
	data: data,
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_3__components_shared_app_tooltip_button__["a" /* default */]
	},
	methods: {
		updateDistribution: updateDistribution,
		postDistribution: postDistribution,
		close: close,
		goToUser: goToUser,
		onSearch: onSearch,
		openConfirmDialog: openConfirmDialog,
		rowIsSelected: rowIsSelected,
		allIsSelected: allIsSelected,
		changePage: changePage,
		returnDistribution: returnDistribution,
		setDataSelected: setDataSelected,
		listDistribution: listDistribution
	},
	props: {
		idDistribution: [Number, String],
		codeProject: String,
		codeTemplate: [Number, String]
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/40.d08cc095f3040b174cfe.js